import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getStudentSubjects } from "../redux/slices/subjectsSlice";
import { fetchExamHistory } from "../redux/slices/examHistorySlice";
import { FaClock, FaBook, FaCheckCircle } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AllExams/AllExams.css";
import { useDarkMode } from "../contexts/DarkModeContext";

function ExamHistory() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { studentSubjects } = useSelector((state) => state.subjects);
  const { history, loading, error } = useSelector((state) => state.examHistory);
  const [activeTab, setActiveTab] = useState("الكل");
  const { isDarkMode } = useDarkMode();

  useEffect(() => {
    dispatch(getStudentSubjects());
  }, [dispatch]);

  // بناء التابس من المواد
  const subjectsTabs = [
    { name: "الكل", id: 0 },
    ...studentSubjects.map((subject) => ({ name: subject.title, id: subject.id })),
  ];

  useEffect(() => {
    const selectedSubject = subjectsTabs.find((s) => s.name === activeTab);
    if (selectedSubject) {
      dispatch(fetchExamHistory(selectedSubject.id));
    }
    // eslint-disable-next-line
  }, [activeTab]);

  return (
    <div className={`questions-section ${isDarkMode ? "dark-mode" : "light-mode"}`}>
      <ToastContainer />
      <div className="container">
        {/* Breadcrumb */}
        <div className="lessons-breadcrumb">
          <h1 className="breadcrumb-title">سجل الاختبارات</h1>
          <div className="breadcrumb-links2">
            <span className="breadcrumb-link">الرئيسية</span>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-current">سجل الاختبارات</span>
          </div>
        </div>
        {/* Tabs */}
        <div className="lessons-tabs">
          <div className="tabs-header">
            <span className="subjects-text">المواد</span>
            <div className="tabs-container">
              {subjectsTabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`tab-button ${activeTab === tab.name ? "active" : ""}`}
                  onClick={() => setActiveTab(tab.name)}
                >
                  {tab.name}
                </button>
              ))}
            </div>
          </div>
        </div>
        {/* Loading State */}
        {loading && (
          <div className="text-center my-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">جاري التحميل...</span>
            </div>
          </div>
        )}
        {/* Error State */}
        {error && (
          <div className="text-center my-4">
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          </div>
        )}
        {/* Cards */}
        {!loading && !error && (
          <div className="exam-cards-grid">
            {history.length > 0 ? (
              history.map((exam) => (
                <div
                  className="exam-card"
                  key={exam.test_id || exam.id}
                  style={{
                    background: isDarkMode
                      ? 'linear-gradient(135deg, #232526 0%, #414345 100%)'
                      : 'linear-gradient(135deg, #e0eafc 0%, #f8fafc 100%)',
                    border: isDarkMode ? '1.5px solid #444' : '1.5px solid #dbeafe',
                    boxShadow: isDarkMode
                      ? '0 8px 32px rgba(0,0,0,0.5)'
                      : '0 8px 32px rgba(80,120,255,0.08)',
                    borderRadius: 24,
                    transition: 'all 0.3s',
                  }}
                >
                  <div className="exam-image-container">
                    <img
                      src={exam.image || exam.subject_image || "/courseimage.png"}
                      alt="Exam"
                      className="exam-image"
                      style={{ borderRadius: 16, border: isDarkMode ? '1px solid #333' : '1px solid #e0eafc' }}
                    />
                  </div>
                  <span className={`exam-status completed`} style={{ background: isDarkMode ? '#27ae60' : '#00b894', color: '#fff' }}>تم الحل</span>
                  <div className="exam-content">
                    <h3 className="exam-title" style={{ color: isDarkMode ? '#fff' : '#222' }}>{exam.title}</h3>
                    <div className="exam-time">
                      <FaClock className="clock-icon" />
                      <span>{exam.duration_time || exam.time || '--:--:--'}</span>
                    </div>
                    <div className="exam-footer">
                      <div className="exam-teacher">
                        <img src="/user.png" style={{ width: "40px", height: "40px" }} alt="Teacher" />
                        <span>{exam.teacher_name || '---'}</span>
                      </div>
                      <div className="exam-subject">
                        <FaBook className="book-icon" />
                        <span>{exam.subject_name || '---'}</span>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="exam-btn start"
                      style={{ zIndex: 9999, position: "relative", pointerEvents: "auto", background: isDarkMode ? '#27ae60' : '#00b894', color: '#fff', fontWeight: 700, borderRadius: 12, marginTop: 10 }}
                      onClick={() => navigate(`/exam-answers/${exam.test_id || exam.id}`)}
                    >
                      <FaCheckCircle style={{ marginLeft: 8, color: '#fff' }} /> عرض الإجابات
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center my-4">
                <p>لا يوجد سجل اختبارات بعد.</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ExamHistory;